/**
 * vue-pdf-embed wrapper that keeps PDF rendering working under our CSP.
 *
 * The default build of vue-pdf-embed inlines pdf.worker.mjs as a
 * `data:text/javascript;base64,...` URL and assigns it to workerSrc itself. Our
 * deployed CSP (see public/.htaccess) lists no `data:` in script-src, so both the
 * real worker and pdf.js's main-thread fallback are blocked and the viewer stays
 * blank. The library documents the essential build for exactly this case: it ships
 * no worker, exposes GlobalWorkerOptions, and lets us point it at a same-origin
 * file, which 'self' already covers in both worker-src and script-src.
 *
 * The worker is copied to the publicPath root at build time by vue.config.js, under a
 * content-hashed name it passes in as process.env.PDF_WORKER_FILE. The essential build
 * embeds its own pdf.js, so package.json pins pdfjs-dist to that exact version - bump
 * both together, pdf.js refuses to run a worker whose version differs from the API.
 */
import VuePdfEmbed, { GlobalWorkerOptions } from 'vue-pdf-embed/dist/index.essential.mjs'

GlobalWorkerOptions.workerSrc = process.env.BASE_URL + process.env.PDF_WORKER_FILE

export default VuePdfEmbed
